import { NUMBER_ITEMS_PER_REQUEST } from 'constants/wallet';
import { WalletTransactionList, WalletTransactionListFilter } from 'models/wallet';

export function initTransactionList(): WalletTransactionList {
  return {
    content: [],
    page: {
      number: 0,
      size: 0,
      totalElements: -1,
      totalPages: 0
    }
  };
}

export function initTransactionListFilter(): WalletTransactionListFilter {
  return {
    size: NUMBER_ITEMS_PER_REQUEST
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/wallet.ts